import { twMerge } from "tailwind-merge";
import type { IconProps } from "./types";

export const CheckPoints1 = ({
  size,
  color,
  className,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={twMerge(color == null && "h-5 w-5 stroke-current", className)}
    stroke={color}
    fill="none"
    {...props}
  >
    <path
      d="M21 12L9 12M21 6L9 6M21 18L9 18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 5.55363L3.08192 6.8143C3.16992 6.91684 3.21392 6.96812 3.26466 6.98733C3.30929 7.00422 3.35737 7.00422 3.402 6.98733C3.45274 6.96812 3.49675 6.91684 3.58475 6.8143L6 4M2 11.5536L3.08192 12.8143C3.16992 12.9168 3.21392 12.9681 3.26466 12.9873C3.30929 13.0042 3.35737 13.0042 3.402 12.9873C3.45274 12.9681 3.49675 12.9168 3.58475 12.8143L6 10M2 17.5536L3.08192 18.8143C3.16992 18.9168 3.21392 18.9681 3.26466 18.9873C3.30929 19.0042 3.35737 19.0042 3.402 18.9873C3.45274 18.9681 3.49675 18.9168 3.58475 18.8143L6 16"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
